import Vue, { PluginObject } from 'vue';
import commonUi from '@momnt-technologies/common-ui';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import exclude from './directives/exclude';

Vue.config.productionTip = false;
Vue.use(commonUi as PluginObject<unknown>);
Vue.directive('exclude', exclude);

(async () => {
  // Config needs to load before we can
  // send out any other API requests.
  await store.dispatch('Config/getConfig');

  new Vue({
    router,
    store,
    vuetify,
    render: (h) => h(App),
  }).$mount('#app');
})();
